import React from "react";
import { CustomTable, Loader, useTabs } from "../../../shared";
import { Button, Chip, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { arraySort, sortItems } from "../../../utils";
import { useRetailProductList } from "../hooks";
import { AppContext } from "../../../store/AppScopeProvider";
import InputControl from "../../../shared/components/InputControl";

export const RetailProductList = (props) => {
  const { setCurentTab } = useTabs();
  const { state, onChangeFilter, applyFilters, resetFilters, isFilterApplied } =
    useRetailProductList();
  const { basicDetails } = props;
  const navigate = useNavigate();
  const { appState } = React.useContext(AppContext);
  const { globalData } = appState;

  const { filteredProducts, loading, filters, hasChanges } = state;

  const columns = React.useMemo(
    () => [
      {
        Header: "Product Name",
        id: "name",
        accessor: "name",
        sortType: (prev, curr, columnId) => sortItems(prev, curr, columnId),
        Cell: ({ row }) => {
          return (
            <Stack direction="row" gap="8px" alignItems="center">
              {row.original.name}
              <img
                alt="link"
                src="/icons/ic_external_link.svg"
                style={{
                  cursor: "pointer",
                  padding: "4px",
                  backgroundColor: "#F6F6F6",
                  borderRadius: "10px",
                  height: "20px",
                }}
                onClick={() => {
                  navigate(`/products/details/${row.original.id}`);
                }}
              />
            </Stack>
          );
        },
      },
      {
        Header: "Category",
        id: "category",
        accessor: "category",
        sortType: (prev, curr, columnId) => sortItems(prev, curr, columnId),
      },
      {
        Header: "PLU Code",
        id: "plu",
        accessor: "plu",
        sortType: (prev, curr, columnId) => sortItems(prev, curr, columnId),
      },
      {
        Header: "Status",
        accessor: "status",
        sortInverted: true,
        Cell: ({ value }) =>
          value === 1 ? (
            <Chip
              label="Active"
              color="success"
              variant="outlined"
              size="small"
            />
          ) : (
            <Chip
              label="Inactive"
              color="success"
              variant="outlined"
              size="small"
              disabled
            />
          ),
      },
    ],
    []
  );

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <CustomTable
          columns={columns}
          data={arraySort(filteredProducts, "name")}
          tableId="retail_products"
          onRowLink={(e) => {
            return `/products/details/${e.id}`;
          }}
          onRowAction={() => {
            setCurentTab("productDetails", "1");
          }}
          filterSection={
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              spacing={2}
              width="100%"
            >
              <InputControl
                type="select"
                name="status"
                label="Status"
                optionValue={globalData.status ?? []}
                width="250px"
                onChange={onChangeFilter}
                value={filters.status}
              />
              <Stack direction="row" spacing={1}>
                <Button
                  sx={{ height: 40 }}
                  variant="contained"
                  onClick={applyFilters}
                  disabled={!hasChanges} // only enable when filters changed
                >
                  Apply
                </Button>

                {isFilterApplied && (
                  <Button
                    type="button"
                    size="medium"
                    variant="text"
                    color="gray"
                    sx={{ minWidth: "40px", p: "8px" }}
                    onClick={resetFilters}
                  >
                    <CloseIcon />
                  </Button>
                )}
              </Stack>
            </Stack>
          }
        />
      )}
    </>
  );
};
